/* export */ function Type(...args) {
	return function() {};
}
exports.Type = Type;